<template>
  <v-dialog v-model="internalModelValue" persistent max-width="420">
    <v-card :style="{ backgroundColor: backgroundColor, borderRadius: '12px' }">
      <v-card-title
        class="text-h6"
        :style="{ 
          color: foregroundColor, 
          textAlign: 'center', 
          marginTop: '20px', 
          fontWeight: '700', 
          fontSize: '18px' 
        }"
      >
        {{ title }}
      </v-card-title>

      <v-card-text :style="{ 
        color: foregroundColor, 
        padding: '24px' 
      }">
        <div v-html="message" style="margin-bottom: 16px; text-align: center; line-height: 1.6;"></div>
        <slot />
        <v-btn
          type="button"
          @click="clickedButton"
          block
          :style="secondaryStyle ? {
            backgroundColor: 'transparent',
            color: foregroundColor,
            border: `1px solid color-mix(in srgb, ${foregroundColor} 40%, transparent)`,
            textTransform: 'none',
            marginTop: '12px',
            fontWeight: '600',
            fontSize: '14px',
            borderRadius: '999px',
            padding: '8px 22px',
          } : {
            backgroundColor: foregroundColor,
            color: backgroundColor,
            border: 'none',
            textTransform: 'none',
            marginTop: '20px',
            fontWeight: '600',
            fontSize: '14px',
            borderRadius: '999px',
            padding: '8px 22px',
          }"
          :class="secondaryStyle ? 'dialog-button-secondary' : 'dialog-button'"
        >
          {{ buttonText }}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "OverlayDialog",
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Alert",
    },
    message: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "OK",
    },
    foregroundColor: {
      type: String,
      default: "#1976D2",
    },
    backgroundColor: {
      type: String,
      default: "#fff",
    },
    secondaryStyle: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalModelValue: this.modelValue,
    };
  },
  watch: {
    modelValue(newVal) {
      this.internalModelValue = newVal;
    },
    internalModelValue(newVal) {
      this.$emit("update:modelValue", newVal);
    },
  },
  methods: {
    clickedButton() {
      this.internalModelValue = false;
      this.$emit('dismissed');
    },
  },
};
</script>

<style scoped>
.dialog-button {
  border-radius: 999px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 2px 8px rgba(0, 109, 62, 0.2) !important;
}

.dialog-button:hover {
  box-shadow: 0 4px 16px rgba(0, 109, 62, 0.3) !important;
  transform: translateY(-1px);
}

.dialog-button-secondary {
  border-radius: 999px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 2px 8px rgba(0, 109, 62, 0.12) !important;
}

.dialog-button-secondary:hover {
  box-shadow: 0 4px 16px rgba(0, 109, 62, 0.2) !important;
  transform: translateY(-1px);
}
</style>
